<template>
  <div class="about">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <div class="space"></div>
      <b-container class="bv-example-row">
        <h1>เกี่ยวกับเรา</h1>
        <br />
        <div class="components">
          <div class="card-columns">
            <b-row cols="1" cols-sm="12" cols-md="4" cols-lg="4">
              <b-col>
                <div class="card calendar-border">
                  <div class="card-body">
                    <a
                    href="UBRU-Smart-booking-Manual-min.pdf"
                    rel="noopener noreferrer"
                    class="item-color"
                    target="_blank"
                    ><i class="fas fa-envelope fa-sm top-icon"></i>
                    คู่มือการจองหนังสือ
                  </a>
                   
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="card calendar-border">
                  <div class="card-body">
                    <!-- <a
                      href="mailto: info.lib@ubru.ac.th"
                      rel="noopener noreferrer"
                      target="_blank"
                      class="item-color"
                      ><i class="fas fa-envelope fa-sm top-icon"></i>
                      info.lib@ubru.ac.th
                    </a> -->
                    <a
                      href="https://lib.ubru.ac.th/"
                      rel="noopener"
                      target="_blank"
                      class="item-color"
                      ><i class="fas fa-globe fa-sm top-icon"> </i>
                      เข้าถึงเว็บไซต์หลัก</a
                    >
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="card calendar-border">
                  <div class="card-body">
                    <!-- <a
                      href="https://lib.ubru.ac.th/"
                      rel="noopener"
                      target="_blank"
                      class="item-color"
                      ><i class="fas fa-globe fa-sm top-icon"> </i>
                     เว็บไซต์หลักของเรา</a
                    > -->
                    <a
                      href="mailto: info.lib@ubru.ac.th"
                      rel="noopener noreferrer"
                      target="_blank"
                      class="item-color"
                      ><i class="fas fa-envelope fa-sm top-icon"></i>
                      info.lib@ubru.ac.th
                    </a>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="card calendar-border">
                  <div class="card-body">
                    <a href="tel:045352056" target="_self" class="item-color"
                      ><i class="fas fa-phone fa-sm top-icon"></i>
                      (045)-352-056 </a
                    >
                  </div>
                </div></b-col
              >
            </b-row>
            <br />
            <br />
            <!-- <hr style="width: 50rem" /> -->
            <b-row cols="1" cols-sm="12" cols-md="12" cols-lg="2">
              <b-col>
                <h4 class="text-left">เปิดบริการทุกวัน เวลา <b>8.30น. - 16.30 น.</b> </h4>
                <p class="text-left">
                  <!-- วันจันทร์ ถึง วันศุกร์ : 8.30น. - 16.30 น. <br />วันเสาร์
                  อาทิตย์ : 8.30 น. - 16.30 น.<br />
                  <br /> -->
                  <b><u>ยกเว้น</u></b> วันหยุดนักขัตฤกษ์ และตามประกาศของมหาวิทยาลัย,
                  ช่วงสอบทางสำนักจะประกาศให้ทราบต่อไป
                </p>
                <hr />
              </b-col>
              <b-col>
                <h4 class="text-left">ติดต่อ</h4>
                <p class="text-left">
                  ที่อยู่ : เลขที่ 2 ถนนราชธานี ตำบลในเมือง อำเภอเมือง
                  จังหวัดอุบลราชธานี <br />อีเมล์ : info.lib@ubru.ac.th
                  <br />เวลาติดต่อ : 08.30 น. - 16.30 น. <br />Hotline :
                  (045)-352-056
                  <br />
                  line: @ubru-library
                </p>
              </b-col>
            </b-row>

            <br />
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12"></div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="icon">
                  <div class="icon__home">
                    <a
                    href="https://www.facebook.com/UBRUlibrary"
                    rel="noopener"
                    target="_blank"
                    class="item-color"
                    >   <i class="fa-brands fa-facebook" style="color: #000000;"></i></a>
                 
                    <!-- <ion-icon name="home"></ion-icon> -->
                  </div>
                  <div class="icon__account">
                    <a
                    href="https://www.youtube.com/channel/UCrX7jl0AyiXuCV4bc2ZWPig"
                    rel="noopener"
                    target="_blank"
                    class="item-color"
                    ><i class="fa-brands fa-youtube" style="color: #000000;"></i></a>
                  
                  </div>
                  <div class="icon__settings">
                    <a
                    href="https://lin.ee/wDCCbDK"
                    rel="noopener"
                    target="_blank"
                    class="item-color"
                    > <i class="fa-brands fa-line" style="color: #000000;"></i></a>
                   
                    <!-- <ion-icon name="settings"></ion-icon> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      
      </b-container>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import axios from "axios";
export default {
  name: "aboutComp",
  components: { sidebar_user },
  data() {
    return {
      orders: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      code: "",
    };
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
    }
    this.getorders();
  },
  methods: {
    getorders() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
  },
};
</script>

<style lang="scss" scoped>
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}

.components {
  width: 100%;
  height: auto;
  border-radius: 3rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
  padding: 30px 50px 50px 50px;
  /* display: grid;
  grid-template-columns: 17.6rem 19rem 20.4rem;
  grid-template-rows: repeat(autofit, min-content);
  grid-column-gap: 5rem;
  grid-row-gap: 2.5rem;*/
  align-items: center;
}

/*  ICONS  */
.icon {
  grid-column: 3 / 4;
  grid-row: 4 / 5;
  display: flex;
  justify-content: space-between;
  &__account,
  &__home,
  &__settings {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
      -0.2rem -0.2rem 0.5rem var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    cursor: pointer;
    color: var(--greyDark);
    transition: all 0.5s ease;

    &:active {
      box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
        inset -0.2rem -0.2rem 0.5rem var(--white);
      color: var(--primary);
    }
    &:hover {
      color: var(--primary);
    }
  }
}

.card-columns .card {
  border-radius: 20px;
}
.calendar-list .card {
  border-radius: 20px;
}

.card-body p {
  margin-bottom: 0px;
}
.card-body a {
  color: #11101d;
  border-bottom: 0;
}
.card-body a:hover {
  text-decoration: none;
}
.card-columns {
  column-count: 1;
}
.card-columns-four {
  column-count: 4;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--greyLight-1);
}

/*media*/
@media (min-height: 414px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}
@media (max-height: 500px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}
</style>
